module.exports = __webpack_public_path__ + "static/media/Ex2-S1.0f2d6666.PNG";